export default __webpack_public_path__ + "static/media/UniversLTStdBold.0464cecd.otf";